<script setup>
import { computed } from 'vue';
import Available from '@components/offer-card/icons/Available.vue';
import { getShorterReadableDate, isDateInFuture } from '@tools/date';
import { trans } from '@elements/translation';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
});

const isAvailable = computed(() => props.offer.is_accessible && props.offer.availability_date);
const availableDate = computed(() => isAvailable.value && props.offer.availability_date.iso);
const dateInFuture = computed(() => isDateInFuture(availableDate.value, Math.floor(Date.now())));
</script>

<template>
  <span v-if="isAvailable" class="hit-label hit-label--available">
    <template v-if="dateInFuture">
      <Available color="#5300d6" />
      {{ trans('offer_card.labels.available_on', { date: getShorterReadableDate(availableDate) }) }}
    </template>
    <template v-else>
      <Available color="#00990f" />
      {{ trans('offer_card.labels.available') }}
    </template>
  </span>
</template>
